import { render, staticRenderFns } from "./IFrameWithForm.vue?vue&type=template&id=6c4099fb&scoped=true"
import script from "./IFrameWithForm.vue?vue&type=script&lang=ts"
export * from "./IFrameWithForm.vue?vue&type=script&lang=ts"
import style0 from "./IFrameWithForm.vue?vue&type=style&index=0&id=6c4099fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4099fb",
  null
  
)

export default component.exports